export default __webpack_public_path__ + "static/1-d1982bc91910e09745554957375f1eb5.jpeg";